export default "__VITE_ASSET__v9qatDqa__"